import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import FormsTable from '../components/formsTable';
import Header from '../components/header';
import AppLayout from '../components/AppLayout'
import { getCategories, getCategoriesForms } from '../logic/categories/action';

const CategoryDetails = () => {
    // [1,2].find
    const params = useParams();
    const dispatch = useDispatch();
    const selector = useSelector((state) => state.categories);
    useEffect(() => {
        getCategories(dispatch);
        getCategoriesForms(dispatch,params.id);
    }, [])
    
  return (
    <AppLayout>
      <div className="w-full h-full">
        <Header/>
        <div className='w-full flex flex-col items-start gap-4 p-4 lg:p-10'>
        <h1 className="font-bold text-2xl">Name - {selector?.data?.find(e=>e?.preset_id === parseInt(params?.id))?.business_type}</h1>
        <h2 className="text-lg">Patient Alias - {selector?.data?.find(e=>e?.preset_id === parseInt(params?.id))?.patient_alias || selector?.data?.find(e=>e?.preset_id === parseInt(params?.id))?.customer_alias}</h2>
        <h2 className="text-lg">Staff Alias - {selector?.data?.find(e=>e?.preset_id === parseInt(params?.id))?.staff_alias}</h2>
        <div className='w-full flex justify-between items-center'>
            <h2 className="font-semibold text-xl">Dynamic forms</h2>
            <Link to={`/admin/categories/${params.id}/forms/add`}><button className="px-4 py-2 bg-primary text-white rounded-lg">Add new form</button></Link>
        </div>
        <FormsTable/>
        </div>
        </div>
    </AppLayout>
  )
}

export default CategoryDetails